export default __webpack_public_path__ + "static/media/Bg_2025_web.7bb0e94c.jpg";